import { TaskStatus } from '@gcv/shared';

import { capitalizeVariables } from 'util/strings.util';
import type { TaskDetails } from '../../tasks/tasks.model';

/**
 * The UI design wants the past participle of "complete". The enum values are grammatically
 * inconsistent: COMPLETE should follow the same pattern as CANCELLED, FAILED, and DELETED.
 */
export const getTaskStatusLabel = (task: TaskDetails | null): string => {
  if (!task?.status) {
    return '--';
  }

  return task.status === TaskStatus.COMPLETE ? 'Completed' : capitalizeVariables(task.status);
};
